const InputField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = "text",
}) => {
const handleInputChange = (e) => {
  if (type === "number") {
    const val = e.target.value;

    // Allow empty string when deleting
    if (val === "") {
      onChange(e);
      return;
    }

    // Convert to number
    const num = Number(val);

    // Block negative values only
    if (num < 0) return;
  }

  onChange(e);
};

  const handleWheel = (e) => {
    if (type === "number") {
      e.target.blur();
    }
  };

  return (
    <div>
      {label && (
        <label className="block text-base sm:text-lg font-semibold text-text-primary mb-3 font-poppins">
          {label}
        </label>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onWheel={handleWheel}
        min={type === "number" ? "" : undefined}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={`w-full px-4 py-3 border border-border rounded-lg placeholder:px-0 placeholder:text-xs focus:outline-none focus:ring-1 focus:ring-primary text-sm
        ${
          type === "number"
            ? "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            : ""
        }`}
      />
    </div>
  );
};

export default InputField;
